import { render } from "./AccessoriesView.vue?vue&type=template&id=da0e0e04"
import script from "./AccessoriesView.vue?vue&type=script&lang=js"
export * from "./AccessoriesView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__